import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "core",
    "thresholdValue",
    "noCoresMessage",
    "someCoresMessage",
    "item",
  ];
  declare thresholdValueTarget: HTMLElement;
  declare coreTargets: HTMLElement[];
  declare noCoresMessageTarget: HTMLElement;
  declare someCoresMessageTarget: HTMLElement;
  declare itemTargets: HTMLElement[];
  threshold: number | undefined;

  connect() {
    this.threshold = 10;
    this.update();
  }

  update(event?: Event) {
    const slider = document.getElementById(
      "distance-threshold"
    ) as HTMLInputElement;
    if (slider) {
      this.threshold = parseFloat(slider.value);
      this.thresholdValueTarget.textContent = slider.value;
    }
    let anyVisible = false;
    this.coreTargets.forEach((core: HTMLElement) => {
      const distances = (core.dataset.distances || "").split(",").map(Number);
      const show = distances.some((d) => d > this.threshold!);
      core.style.display = show ? "" : "none";
      if (show) anyVisible = true;
    });
    // Highlight distances above threshold
    this.itemTargets.forEach((li: HTMLElement) => {
      const distance = parseFloat(li.dataset.distance || "0");
      if (distance > this.threshold!) {
        li.classList.add("text-red-600");
      } else {
        li.classList.remove("text-red-600");
      }
    });
    if (anyVisible) {
      this.noCoresMessageTarget.style.display = "none";
      this.someCoresMessageTarget.style.display = "";
    } else {
      this.noCoresMessageTarget.style.display = "";
      this.someCoresMessageTarget.style.display = "none";
    }
  }
}
